"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityCampaignFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var LiquidityCampaignFactory = /** @class */ (function (_super) {
    __extends(LiquidityCampaignFactory, _super);
    function LiquidityCampaignFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    LiquidityCampaignFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    LiquidityCampaignFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    LiquidityCampaignFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    LiquidityCampaignFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    LiquidityCampaignFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return LiquidityCampaignFactory;
}(contracts_1.ContractFactory));
exports.LiquidityCampaignFactory = LiquidityCampaignFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "ClaimableStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Recovered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardPaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newDuration",
                type: "uint256",
            },
        ],
        name: "RewardsDurationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "daoAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "earned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "exit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getCurrentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getReward",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_arcDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsDistributor",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "_daoAllocation",
                type: "tuple",
            },
        ],
        name: "init",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastTimeRewardApplicable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_reward",
                type: "uint256",
            },
        ],
        name: "notifyRewardAmount",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenAmount",
                type: "uint256",
            },
        ],
        name: "recoverERC20",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDistributor",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_rewardsDistributor",
                type: "address",
            },
        ],
        name: "setRewardsDistributor",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_rewardsDuration",
                type: "uint256",
            },
        ],
        name: "setRewardsDuration",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "setTokensClaimable",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakers",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardPerTokenPaid",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardsEarned",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardsReleased",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "userAllocation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=LiquidityCampaignFactory.js.map